import styled from 'styled-components';

export const UnstyledButton = styled.button`
  color: inherit;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;
